import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { OlaMaps } from 'app/OlaMapsWebSDK/olamaps-js-sdk.es';
import 'app/OlaMapsWebSDK/style.css';
import { DEFAULT_MAP_BOUNDS } from '../../constants';


const EventMap = (props) => {
  const {
    showHeader,
    setFormData, 
    formData, 
    isMarkerDraggable = true, 
  } = props;

  const mapRef = useRef(null);

  useEffect(() => {
    const initializeMap = async () => {
      if (!mapRef.current) return; // Ensure the map container is defined

      const olaMaps = new OlaMaps({
        apiKey: 'ntZp3UYw8sQjqjF1SnSvffI2QBeZaA0gProAtSD0',
      });

      if (mapRef.current) {
        const myMap = await olaMaps.init({
          style: "https://api.olamaps.io/tiles/vector/v1/styles/default-light-standard/style.json",
          container: mapRef.current,
          center: [formData?.event_address?.location?.lng || 80.2707, formData?.event_address?.location?.lat || 13.0827],
          zoom: 15,
        });

        myMap.on("fail", () => console.log('ola maps failed to load'));
    
        const marker = olaMaps.addMarker({
          offset: [0, 6],
          anchor: 'bottom',
          color: 'red',
          draggable: isMarkerDraggable,
        })
        .setLngLat([formData?.event_address?.location?.lng || 80.2707, formData?.event_address?.location?.lat || 13.0827])
        .addTo(myMap);
    
        marker.on('dragend', () => {
          const lngLat = marker.getLngLat();
          const newLat = lngLat.lat;
          const newLng = lngLat.lng;

          setFormData({
            ...formData,
            event_address: {
              ...formData?.event_address,
              location: { lat: newLat, lng: newLng },
            },
          });
        });

        const handleMapClick = () => {
          const lat = formData?.event_address?.location?.lat || 13.0827;
          const lng = formData?.event_address?.location?.lng || 80.2707;
          const googleMapsUrl = `https://www.google.com/maps?q=${lat},${lng}`;
          window.open(googleMapsUrl, '_blank');
        };
      
        myMap.on('click', handleMapClick);  
      }
    };

    initializeMap();

    return () => {
      if (mapRef.current) mapRef.current.remove();
    };
  }, []);

  return (
    <>
      {showHeader && <h1 className='heading-36 mb-9'>Pin the right location</h1>}
      <div className='ola-map-container flex-1 h-full' id="ola-maps-container" ref={mapRef} />
    </>
  );
};

EventMap.propTypes = {
  showHeader:PropTypes.bool,
  setFormData: PropTypes.func,
  formData: PropTypes.object,
};

EventMap.defaultProps = {
  showHeader:true,
  setFormData: () => {},
  formData: {},
};


export default EventMap;
